export enum ProcoreGridColumnEnum {
  Target,
  Code,
  Description,
  Message,
  AdditionalField
}
